var preload = {
	
	isFinished : false,
	animating: true,
	
	
	init: function(){
		if( window.canLoad ){
			ani.orientation();
			app.checkOrientation(true);
			ani.preloader();
			
			$('.viewport').show();
			
			ani.preloaderIn.play();
			
			preload.releaseCheck();
			
			app.dispatcher.addEventListener(EVENTS.INTRO_PRELOAD_READY,preload.start);
		}
		
		//Load the animations
		
	},
	
	start : function(){
		app.dispatcher.addEventListener("AM_COMPLETE_G",preload.finished);
		app.dispatcher.addEventListener("AM_PROGRESS_G",preload.update);
		app.loader = new AssetManager(settings.preloader,app.dispatcher);
	},


	update:function(event, data) {
		
		var percent =  Math.round(data);
		
		//Add preceeding 00's
		if (percent < 10 ) {
			percent = '00'+percent+'%';
		
		} else if (percent < 100 ) {
			percent = '0'+percent+'%';
		
		} else {
			percent = percent+'%';
		} 
		
		$(dom.preloader.percent).html( percent );
	},
	
	finished:function(event){
		
		
		
		preload.isFinished = true;
		
		$(dom.preloader.wrapper).toggleClass('is-loading is-loaded');
		
		$(dom.logo.ele).removeClass('is-animated');
		
		//remove % and add app name
		
		ani.preloadReady.seek(0).play();
		
				//Init App.js
				app.init();

				//Check there isnt a url#
				if (window.location.hash.length === 0) {
					
					page.change('landing'); // go straight to landing page
				
				} else {
					
					//app.uiView.autoCredits();
					
					$(dom.preloader.button).addClass('is-shown');//Load cta to link to recieve page
				}
	},

	
	releaseCheck:function(){
		var today = new Date(),
			 release = new Date(localisation.release_date.date.system)
		;

		if ( release <= today ) {
			//alert();
// 			$('body').addClass('film-is-released'); //Add body Class if not already
			$(dom.release.pre).remove(); //remove unwanted html
			app.filmReleased = true; //track in app.js
		}
		
		else {	
			
// 			$('body').addClass('film-not-released'); //Add body Class if not already
			$(dom.release.post).remove(); // remove unwanted html
			app.filmReleased = false; //track in app.js
		}
	},
	
	subPixelFix: function(e) {
			console.log(e)
		var w = Math.ceil(e.width());
		console.log("floor"+w)
		$(e).css('width', w);
		
		console.log(e + w);
	},
	
	fixSubpixelLayout : function (container, items) {
 
    var width = container.width(),
        itemWidth = width / items.length,
        roundedItemWidth = Math.floor(itemWidth);
 
    // the fix is only necessary when the browser width isn't
    // evenly divisible by the number of items
    if(roundedItemWidth !== itemWidth) {
 
        var roundingError = width - (roundedItemWidth * items.length),
            itemCounter = 0,
            currItem;
 
        while(items.length > 0) {
 
            // alternate between the first item in the container...
            if(itemCounter++ % 2 === 0) {
                // get the first item in items
                currItem = items.get(0);
                // remove the first item from items
                items.splice(0,1);
            }
 
            // and the last item in the container
            else {
                // get the last item in items
                currItem = items.get(-1);
                // remove the last item from items
                items.splice(items.length-1, 1);
            }
 
            // adjust the width of the current item accordingly
 
            if(roundingError > 0) {
                $(currItem).width(roundedItemWidth + 1);
                roundingError--;
            }
 
            else {
                $(currItem).width(roundedItemWidth);
            }
 
        }
 
    }
 
    // when the fix isn't necessary, remove any current widths
    else {
        items.width('');
    }
 
	}
};